import { render, staticRenderFns } from "./fold5.vue?vue&type=template&id=54cb4b92&scoped=true&"
import script from "./fold5.vue?vue&type=script&lang=js&"
export * from "./fold5.vue?vue&type=script&lang=js&"
import style0 from "./fold5.vue?vue&type=style&index=0&id=54cb4b92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cb4b92",
  null
  
)

export default component.exports